import type { EnvironmentPreset, RenderObject } from '@v2/contracts'

const SURFACES: Record<EnvironmentPreset, readonly [string, string, string]> = {
  ocean: ['#746a51', '#d6bd87', '#315d53'],
  space: ['#283242', '#83a5b0', '#233746'],
  simple: ['#493a2e', '#bca578', '#284b40'],
}

/** Only the shared table changes material. Authored pieces and mats keep their colors. */
export function styleTableSurface(object: RenderObject, preset: EnvironmentPreset): RenderObject {
  const index = ['__table:wood', '__table:inlay', '__table:felt'].indexOf(object.id)
  return index < 0 ? object : { ...object, color: SURFACES[preset][index] }
}
